/*______________________________1. FIREBASE______________________________*/

  // 1.1 Imports
    //React
    import { useState, useEffect } from 'react';
    // SDKs
    import { initializeApp } from "firebase/app";
    import { getAnalytics } from "firebase/analytics";
    import { getAuth, onAuthStateChanged, createUserWithEmailAndPassword, signInWithEmailAndPassword, signOut } from "firebase/auth";
    import { getStorage, ref, uploadBytes, uploadString, getDownloadURL } from "firebase/storage";
    import { getFirestore, collection, doc, getDocs, getDoc, addDoc, deleteDoc, query, orderBy, where, limit, writeBatch, increment } from "firebase/firestore";
    // UUID
    import Resizer from "react-image-file-resizer"
    import { v4 } from 'uuid'


  //1.2 Web app's Firebase configuration
    const firebaseConfig = {
      apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
      authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
      projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
      storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
      messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
      appId: process.env.REACT_APP_FIREBASE_APP_ID,
      measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID
    };


  //1.3 Initialize Firebase
    const app = initializeApp(firebaseConfig);
    const analytics = getAnalytics(app);
    const auth = getAuth();
    export const storage = getStorage(app);
    const db = getFirestore ();


  //1.4 Collections
    const combosCollection = collection(db, "combos");
    const itemsCollection = collection(db, "items");
    const ordersCollection = collection(db, "orders");




/*______________________________2. ITEMS______________________________*/

  //2.1 Get all items
    export const getItems = async () => {
      const q = query(itemsCollection, orderBy("code", "asc"));
      const querySnapshot = await getDocs(q);
      let itemsList = [];
      querySnapshot.forEach(doc => {
        itemsList.push({
          ...doc.data(),
          id: doc.id
        });
      });
      return itemsList
    }

  //2.2 Get items by category
    export const getItemsFiltered = async (prop, value) => {
      const q = query(itemsCollection, where(prop, "==", value), orderBy("code", "asc"));
      const querySnapshot = await getDocs(q);
      let itemsList = [];
      querySnapshot.forEach((doc) => {
        itemsList.push({
          ...doc.data(),
          id: doc.id
        });
      });
      return itemsList
    }

  //2.3 Get items by Id
    export const getItemsById = async (id) => {
      const docRef = doc(itemsCollection, id);
      const docSnap = await getDoc(docRef);
      return docSnap.data()
    }




/*______________________________3. COMBOS______________________________*/

  //3.1 Get all combos
    export const getCombos = async () => {
      const q = query(combosCollection, orderBy("code", "asc"));
      const querySnapshot = await getDocs(q);
      let combosList = [];
      querySnapshot.forEach(doc => {
        combosList.push({
          ...doc.data(),
          id: doc.id
        });
      });
      return combosList
    }

  //3.2 Get combos by category
    export const getCombosByCategory = async (prop, value) => {
      const q = query(combosCollection, where(prop, "array-contains", value), orderBy("code", "asc"));
      const querySnapshot = await getDocs(q);
      let combosList = [];
      querySnapshot.forEach((doc) => {
        combosList.push({
          ...doc.data(),
          id: doc.id
        });
      });
      return combosList
    }

  //3.3 Get combos by Id
    export const getCombosById = async (id) => {
      const docRef = doc(combosCollection, id);
      const docSnap = await getDoc(docRef);
      return docSnap.data()
    }



/*______________________________4. ORDERS______________________________*/

  //4.1 Complete order
    export const addOrder = async (order) => {
      const docSnap = await addDoc(ordersCollection, order);
      return docSnap.id
    }

  //4.2 Send order to wap
    export const wapOrder = async (order) => {
      const number = 5492216194481;
      const message = JSON.stringify( `Hola, soy ${order.buyer.name}, `+`y quiero realizar el siguiente pedido:`+
                                      `${order.cart.map(i => ["%0ACód. ",i.code,"x",i.qty,"unidades"].join("%20"))}`+
                                      `%0ATotal *$ ${order.total}*`+
                                      `%0AAguardo la confirmación el próximo día hábil de 08 a 16 hs`
      );
      const url = `https://wa.me/${number}/?text=${message}`
      window.open(url);
    }

  //4.3 Update stock
    export const updateStock = async (id, qty) => {
      const stock = increment(-qty);
      const docRef = doc(db, "items", id);
      const batch = writeBatch(db);
      batch.update(docRef, {stock});
      await batch.commit();
    }
    export const updateStock2 = async (id, qty) => {
      const stock = increment(-qty);
      const docRef = doc(db, "combos", id);
      const batch = writeBatch(db);
      batch.update(docRef, {stock});
      await batch.commit();
    }

  //4.4 Cancel order
  export const cancelOrder = (order) => {  
    const number = 5492216194481
    const message = JSON.stringify( `Hola, soy ${order.buyer.name}`+
                                    `, y quiero cancelar mi pedido realizado recientemente`
    )
    const url = `https://wa.me/${number}/?text=${message}`
    window.open(url);
  }

  //4.5 Get orders by Id
    export const getOrdersById = async (id) => {
      const docRef = doc(ordersCollection, id);
      const docSnap = await getDoc(docRef);
      return docSnap.data()
    }


/*______________________________5. ADMIN USER______________________________*/

  //5.1 Create User, se usa en Admin
    export const signUpFunction = ( email, password ) => {
      return createUserWithEmailAndPassword(auth, email, password)
    }

  //5.2 Sign In, se usa en Admin
    export const signInFunction = ( email, password ) => {
      return signInWithEmailAndPassword(auth, email, password)
    }

  //5.3 Logged User, se usa en Admin
  export const useAuth = ( ) => {
    const [currentUser, setCurrentUser] = useState();
    useEffect(() => {
      const unsuscribe = onAuthStateChanged(auth, (user) => setCurrentUser(user));
      return unsuscribe
    }, [])
    return currentUser;
  }

  //5.4 Sign Out, se usa en Admin
    export const signOutFunction = ( ) => {
      return signOut(auth)
    }




/*______________________________6. ADMIN ITEMS______________________________*/

  //6.1 Upload item picture, se usa en ItemNew & ItemEdit
    // Resize it
    const resizeFile = (file) =>
    new Promise((resolve) => {
      Resizer.imageFileResizer(file, 576, 576, "JPEG", 95, 0, (uri) => {
        resolve(uri);
      });
    })
    // Upload it
    export const uploadPicture = async (file) => {
      const uri = await resizeFile(file);
      const storageRef = ref(storage, `itemPictures/${v4()}`);
      await uploadString(storageRef, uri, "data_url");
      const url = await getDownloadURL(storageRef);
      return url
    }

  //6.2 New item, se usa en ItemNew
    export const newItem = async ( code, category, name, description, picture, priceText, stockText ) => {
      const priceWithoutFormat = parseFloat(priceText);
      const price = Math.round(priceWithoutFormat * 1e2) / 1e2;
      const stock = parseInt(stockText);
      const payload = { code, category, name, description, picture, price, stock };
      await addDoc(itemsCollection, payload)
    }

  //6.3 Delete item, se usa en ItemCardEdition
    export const deleteItem = async (id) => {
      let result = window.confirm("¿Está seguro? Esta acción no se puede deshacer")
      if (result) {
        const docRef = doc(db, "items", id);
        await deleteDoc(docRef);
      }
    } 

  //6.4 Update item, se usa en ItemEdit
    export const updateItem = async (id, newCode, newCategory, newName, newDescription, newPicture, newPrice, newStock) => {
      const code = newCode;
      const category = newCategory;
      const name = newName;
      const description = newDescription;
      const picture = newPicture;
      const priceWithoutFormat = parseFloat(newPrice);
      const price = Math.round(priceWithoutFormat * 1e2) / 1e2;
      const stock = parseInt(newStock);
      const docRef = doc(itemsCollection, id);
      const batch = writeBatch(db);
      batch.update(docRef, {code, category, name, description, picture, price, stock});
      await batch.commit();
    }

  //6.5 Update item code, se usa en ItemCard
    export const updateItemCode = async (id) => {
      const code = prompt("Ingrese el nuevo código") || code;
      const docRef = doc(db, "items", id);
      const batch = writeBatch(db);
      batch.update(docRef, {code});
      await batch.commit();
    }

  //6.6 Update item price, se usa en ItemCard
    export const updateItemPrice = async (id) => {
      const priceWithoutFormat = parseFloat(prompt("Ingrese el nuevo precio")) || price;
      const price = Math.round(priceWithoutFormat * 1e2) / 1e2;
      const docRef = doc(db, "items", id);
      const batch = writeBatch(db);
      batch.update(docRef, {price});
      await batch.commit();
    }
  
  //6.7 Update item stock, se usa en ItemCardEdition
    export const updateItemStock = async (id) => {
      const stock = parseInt(prompt("Ingrese el stock disponible")) || stock;
      const docRef = doc(db, "items", id);
      const batch = writeBatch(db);
      batch.update(docRef, {stock});
      await batch.commit();
    }
    
    //6.8 Update all combo prices, se usa en CombosList
    export const updateAllItemsPrices = async (id, oldPrice, percentaje) => {
      const percentajeEntered = parseFloat(percentaje) || 0;
      const coefficient = Math.round((percentajeEntered * oldPrice / 100) * 1e2) / 1e2
      const price = Math.round((oldPrice + coefficient) * 1e2) / 1e2
      const docRef = doc(db, "items", id);
      const batch = writeBatch(db);
      batch.update(docRef, {price});
      await batch.commit();
    }

    //6.9 Update item various, por el momento no se usa
    export const updateItemVarious = async (id) => {
      const priceWithoutFormat = parseFloat(prompt("Ingrese el nuevo precio")) || price;
      const price = Math.round(priceWithoutFormat * 1e2) / 1e2;
      const stock = parseInt(prompt("Ingrese el stock disponible")) || stock;
      const docRef = doc(db, "items", id);
      const batch = writeBatch(db);
      batch.update(docRef, {price, stock});
      await batch.commit();
    }
  
  
  
  
/*______________________________7. ADMIN COMBOS______________________________*/

  //7.1 Upload combo picture, se usa en CombosNew & CombosEdit
    // Resize it Declared in uploaditempicture
    // Upload it
    export const uploadComboPicture = async (file) => {
      const uri = await resizeFile(file);
      const storageRef = ref(storage, `combosPictures/${v4()}`);
      await uploadString(storageRef, uri, "data_url");
      const url = await getDownloadURL(storageRef);
      return url
    }

  //7.2 New combo, se usa en CombosNew
    export const newCombo = async ( code, category, name, description, picture, priceText, stockText ) => {
      const priceWithoutFormat = parseFloat(priceText);
      const price = Math.round(priceWithoutFormat * 1e2) / 1e2;
      const stock = parseInt(stockText);
      const payload = { code, category, name, description, picture, price, stock };
      await addDoc(combosCollection, payload)
    }

  //7.3 Delete combo
    export const deleteCombo = async (id) => {
      let result = window.confirm("¿Está seguro? Esta acción no se puede deshacer")
      if (result) {
        const docRef = doc(db, "combos", id);
        await deleteDoc(docRef);
      }
    }

  //7.4 Update combos, se usa en CombosEdit
    export const updateCombo = async (id, newCode, newCategory, newName, newDescription, newPicture, newPrice, newStock) => {
      const code = newCode;
      const category = newCategory;
      const name = newName;
      const description = newDescription;
      const picture = newPicture;
      const priceWithoutFormat = parseFloat(newPrice);
      const price = Math.round(priceWithoutFormat * 1e2) / 1e2;
      const stock = parseInt(newStock);
      const docRef = doc(combosCollection, id);
      const batch = writeBatch(db);
      batch.update(docRef, {code, category, name, description, picture, price, stock});
      await batch.commit();
    }

    //7.5 Update item code, se usa en ItemCard
    export const updateComboCode = async (id) => {
      const code = prompt("Ingrese el nuevo código") || code;
      const docRef = doc(db, "combos", id);
      const batch = writeBatch(db);
      batch.update(docRef, {code});
      await batch.commit();
    }
    
    //7.6 Update combo price, se usa en CombosCard
    export const updateComboPrice = async (id) => {
      const priceWithoutFormat = parseFloat(prompt("Ingrese el nuevo precio")) || price;
      const price = Math.round(priceWithoutFormat * 1e2) / 1e2;
      const docRef = doc(db, "combos", id);
      const batch = writeBatch(db);
      batch.update(docRef, {price});
      await batch.commit();
    }
  
    //7.7 Update combo stock, se usa en CombosCardEdition
      export const updateComboStock = async (id) => {
        const stock = parseInt(prompt("Ingrese el stock disponible")) || stock;
        const docRef = doc(db, "combos", id);
        const batch = writeBatch(db);
        batch.update(docRef, {stock});
        await batch.commit();
      }

    //7.8 Update all combo prices, se usa en CombosList
    export const updateAllCombosPrices = async (id, oldPrice, percentaje) => {
      const percentajeEntered = parseFloat(percentaje) || 0;
      const coefficient = Math.round((percentajeEntered * oldPrice / 100) * 1e2) / 1e2
      const price = Math.round((oldPrice + coefficient) * 1e2) / 1e2
      const docRef = doc(db, "combos", id);
      const batch = writeBatch(db);
      batch.update(docRef, {price});
      await batch.commit();
    }




/*______________________________8. ADMIN ORDERS______________________________*/

  //8.1 Delete Order, se usa en OrderCard
    export const deleteOrder = async (id) => {
      let result = window.confirm("¿Está seguro? Esta acción no se puede deshacer")
      if (result) {
        const docRef = doc (db, "orders", id)
        await deleteDoc(docRef);
      }
    }

